import React from 'react';
import moment from 'moment';
import NoDataMsg from 'library/noData';

const Body = ({ manualInventoryChange, endDate, beginDate }) => (

    <div>
        {
            manualInventoryChange.length <= 0 ?
                //If there's NO DATA to display
                <NoDataMsg />
                :
                manualInventoryChange.length > 0 &&
                //If there's DATA
                <div>
                    <div className="row m-0">
                        <div className="text-center list_header">
                            {beginDate ?
                                <p><i>From</i> <b>{moment(beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                                    {endDate ? <b>{moment(endDate).format('MMMM Do, YYYY')}</b> : moment().format('MMMM Do, YYYY')}</p>
                                : ""}
                        </div>
                    </div>
                    <div className="table-responsive">
                        {
                            manualInventoryChange.map((item, index) => {

                                return (
                                    <div className="row m-0 mb-2" key={index}>

                                        <div className="col-lg-12 title_th">
                                            {/* <h3 className="m-0">{moment(item.date).format('MMMM Do, YYYY')}</h3> */}
                                            <h3 className="m-0">{moment(item.date).format('MMMM Do, YYYY')}</h3>
                                        </div>{/* row - Date */}

                                        <div className="col-lg-2 text-center border-right">
                                            <h4 className="m-0 grey-text">Category Name:{item.categoryName}</h4>
                                            <br />
                                            <h4 className="m-0 grey-text">Product Name:{item.productName}</h4>
                                            <br />
                                            <h4 className="m-0 grey-text">SKU:{item.sku}</h4>
                                        </div> {/* Column Orders */}

                                        <div className="col-lg-10 text-center daily_cash border-right">
                                            <div className="row m-0">
                                                <div className="col-lg-6 col-md-4 col-sm-12 col-xs-12 m-0 p-0">

                                                    <div className="col-lg-3 col-md-4 col-sm-4 col-xs-6 col-md- m-0 p-0">
                                                        {/* <div className="table_icon"><ActionStore/></div> */}
                                                        <label>Employee name</label>
                                                        <h3 className="m-0 grey-text">{(item.employeeName)}</h3>
                                                    </div>

                                                    <div className="col-lg-3 col-md-4 col-sm-4 col-xs-6 col-md- m-0 p-0">
                                                        {/* <div className="table_icon"><ActionStore/></div> */}
                                                        <label>Action</label>
                                                        <h3 className="m-0 grey-text">{(item.action === 1 ? "Increase" : "Decrease")}</h3>
                                                    </div>

                                                    <div className="col-lg-3 col-md-4 col-sm-4 col-xs-6 col-md- m-0 p-0 m-0 p-0">
                                                        {/* <div className="table_icon"><ActionCreditCard/></div> */}
                                                        <label>Reason</label>
                                                        {!item.otherReductionReason ?
                                                            <h3 className="m-0 grey-text">{reasons[item.reason]}</h3>
                                                            : item.otherReductionReason.length < 20 ?
                                                                <h3 className="m-0 grey-text">{reasons[item.reason] + "-" + item.otherReductionReason}</h3>
                                                                : ""}


                                                    </div>

                                                    <div className="col-lg-3 col-md-4 col-sm-4 col-xs-6 col-md- m-0 p-0 m-0 p-0">
                                                        {/* <div className="table_icon"><ActionCreditCard/></div> */}
                                                        <label>Lot number</label>
                                                        <h3 className="m-0 grey-text">{item.packageReference}</h3>
                                                    </div>


                                                </div>

                                                <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 m-0 p-0">

                                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 col-md- m-0 p-0">
                                                        {/* <div className="table_icon"><EditorAttachMoney/></div> */}
                                                        <label>Previous Qty</label>
                                                        <h3 className="m-0 grey-text">{(item.previousQuantity)}</h3>
                                                    </div>

                                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 col-md- m-0 p-0">
                                                        {/* <div className="table_icon"><EditorAttachMoney/></div> */}
                                                        <label>Difference</label>
                                                        <h3 className="m-0 grey-text">{(item.difference)}</h3>
                                                    </div>

                                                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-6 col-md- m-0 p-0">
                                                        {/* <div className="table_icon"><EditorAttachMoney/></div> */}
                                                        <label>New Qty</label>
                                                        <h3 className="m-0 grey-text">{(item.newQuantity)}</h3>
                                                    </div>

                                                </div>

                                                <div className="col-lg-2 col-md-4 col-sm-4 col-xs-6 col-md- m-0 p-0 border-left">
                                                    {/* <div className="table_icon"><EditorAttachMoney/></div> */}
                                                    <label>Warehouse Name</label>
                                                    <h3 className="m-0 green-text"><strong>{item.warehouseName}</strong></h3>
                                                </div>
                                            </div>
                                        </div>{/* Column Icons */}
                                    </div>
                                );
                            })
                        }

                    </div>
                </div>
        }
    </div>
);

let reasons = {
    5: "Destroyed/Damaged",
    6: "Manual Addition",
    7: "Lost/Theft",
    8: "Returned to Distributor",
    9: "Other Reduction",
    10: "Other Addition",
    11: "Transfer Between Branches",
    12: "Receive From Another Branch",
    15: "Bulk To Unit"
}

export default Body;